<template>
  <div id="page">
    <h2 class="page-header">Form Builder</h2>
    <div class="vx-card p-6">
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
      >
        <tab-content title="Step 1" class="mb-5" :before-change="validateStep1">
          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span>Type</span>
                <div class="demo-alignment">
                  <vs-radio v-model="FormType" vs-value="1">Poll</vs-radio>
                  <vx-tooltip
                    text="Gather data about questions usually limited to 1-3 using polls to make it easy for users to answer them by mapping to Sessions."
                    position="top"
                  >
                    <span class="ml-2 info-ico">i</span>
                  </vx-tooltip>
                  <vs-radio v-model="FormType" vs-value="2">Survey</vs-radio>
                  <vx-tooltip
                    text="Use this to present set of questions to find out peoples' opinions and ideas,trends to draw a bigger picture."
                    position="top"
                  >
                    <span class="ml-2 info-ico">i</span>
                  </vx-tooltip>
                  <vs-radio v-model="FormType" vs-value="3">Form</vs-radio>
                  <vx-tooltip
                    text="Use it for gathering just about any type of data through a set of questions for a specific purpose."
                    position="top"
                  >
                    <span class="ml-2 info-ico">i</span>
                  </vx-tooltip>
                  <span class="text-danger"></span>
                </div>
              </div>
              <div class="vx-col md:w-1/2 mt-5">
                <span>Name</span>
                <vs-input
                  label
                  v-model="FormName"
                  class="w-full"
                  name="form_name"
                  v-validate="'required|alpha_spaces'"
                />
              </div>
            </div>
            <div class="vx-row mt-5" v-show="FormType == '2'">
              <span>Map To</span>
              <div class="w-full">
                <!--<v-select :options="MapToOptions" :value="['Event']" class="mt-5"></v-select>-->
                <vs-select
                  v-model="MapTo"
                  class="w-full"
                  label
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in MapToOptions"
                    class="w-full"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  />
                </vs-select>
              </div>
            </div>
            <div class="vx-row mt-5" v-show="FormType == '3'">
              <div class="w-full">
                <span>Visible To</span>
                <v-select
                  multiple
                  :closeOnSelect="false"
                  v-model="VisibleTo"
                  :options="VisibleToOptions"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
                <!--<vs-select
              multiple
              v-model="VisibleTo"
              label="Visible To"
              class="w-full select-large"
              :closeOnSelect="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in VisibleToOptions"
                class="w-full"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
                </vs-select>-->
              </div>
            </div>
            <div
              class="vx-row mt-5 mapped-form-sessions"
              v-show="FormType == '1' || (FormType == '2' && MapTo == '2')"
            >
              <span>Map To Sessions</span>
              <!--<vs-select v-model="Session" class="w-full select-large" label="Session">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in sessionOptions"
                class="w-full"
              />
              </vs-select>-->
              <!--<vx-input-group
            v-for="(item,index) in sessionOptions"
            class="mb-base"
            prependClasses="border border-solid border-grey border-r-0"
          >
            <template slot="prepend">
              <div class="prepend-text">
                <vs-checkbox v-model="item.value"></vs-checkbox>
              </div>
            </template>
            <vs-input>{{item.text}}</vs-input>
              </vx-input-group>-->
              <ag-grid-vue
                ref="agGridTable"
                :components="components"
                :gridOptions="gridOptions"
                class="ag-theme-material w-full my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="sessionOptions"
                rowSelection="multiple"
                colResizeDefault="shift"
                :enableRtl="$vs.rtl"
              ></ag-grid-vue>
            </div>
          </form>
        </tab-content>
        <!-- tab 2 content -->
        <tab-content title="Step 2" class="mb-5" :before-change="validateStep2">
          <form data-vv-scope="step-2">
            <div class="vx-row">
              <div class="vx-col w-full button-wrap">
                <vs-button color="rgb(76, 139, 246)" type="filled" @click="popupActive = true"
                  >Preview</vs-button
                >
                <vs-popup
                  class="holamundo"
                  title="Form Preview"
                  :active.sync="popupActive"
                >
                  <!-- form rendering -->
                  <div class="q-pa-md q-form-container">
                    <h4>Form Preview</h4>
                    <div v-for="(field, index) in fields" :key="index">
                      <component
                        v-model="fieldData[field.cid]"
                        @input="onInput"
                        v-bind:is="getElement(field)"
                        :label="field.label"
                        :required="field.required"
                        :field_options="field.field_options"
                        :id="field.cid"
                        :cid="field.cid"
                        :ref="field.cid"
                        debounce="500"
                      />
                    </div>
                  </div>
                </vs-popup>
              </div>
              <div class="w-full">
                <q-form-builder
                  v-model="fields"
                  :source-fields="mySourceFields"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="w-full">
                <q-separator />
              </div>
            </div>
          </form>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Step 3" class="mb-5" :before-change="validateStep3">
          <form data-vv-scope="step-3">
            <div class="vx-row">
              <div class="vx-col md:w-1/4 w-full">
                <vs-input
                  label="Submit Button Text"
                  v-model="SubmitButtonText"
                  class="w-full mt-5"
                  name="submit_button_text"
                  v-validate="'required|alpha_spaces'"
                  placeholder="Submit Button Text"
                />
              </div>
              <div class="vx-col md:w-1/4 w-full demo-bottom-alignment">
                <vs-button color="rgb(76, 139, 246)" type="filled" class="mt-3">{{
                  SubmitButtonText
                }}</vs-button>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <vs-input
                  label="Redirect To"
                  v-model="RedirectTo"
                  class="w-full mt-5"
                  name="redirect_url"
                />
                <span class="text-danger"></span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mt-5">
                <span class="w-full vs-input--label">Submit Message</span>
                <vs-textarea v-model="SubmitMessage" />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input
                  label="On Submit Send Mail To (Enter email separated by comma)"
                  v-model="SubmitRecipients"
                  class="w-full"
                  name="submit_recipient"
                />
                <span class="text-danger"></span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="demo-alignment">
                  <span>Allow Multiple Submission</span>
                  <div class="flex">
                    <vs-switch v-model="AllowMultipleSubmission" />
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="demo-alignment mt-4">
                  <span>Allow Edit</span>
                  <div class="flex">
                    <vs-switch v-model="AllowEditAfterSubmission" />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage";
var cn = ls.getSessionEventCollectionName();

import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "q-form-builder/dist/css/app.6f06bd74.css";
import QFormBuilder from "./QFormBuilder";
import vSelect from "vue-select";
// For custom error message
import { Validator } from "vee-validate";
const dict = {
  custom: {
    form_name: {
      required: "Form name is required",
      alpha: "Form name may only contain alphabetic characters",
    },
    last_name: {
      required: "Last name is required",
      alpha: "Last name may only contain alphabetic characters",
    },
    email: {
      required: "Email is required",
      email: "Please enter valid email",
    },
    job_title: {
      required: "Job title name is required",
      alpha: "Job title may only contain alphabetic characters",
    },
    proposal_title: {
      required: "Proposal title name is required",
      alpha: "Proposal title may only contain alphabetic characters",
    },
    event_name: {
      required: "Event name is required",
      alpha: "Event name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
var vm;
import {
  TextElement,
  ParagraphElement,
  CheckboxesElement,
  RadioElement,
  DateElement,
  TimeElement,
  DropdownElement,
  EmailElement,
  NameElement,
  SimpleNameElement,
  AddressElement,
  PhoneElement,
  FileElement,
  PaymentElement,
  TermsElement,
  PageBreakElement,
  SectionBreakElement,
} from "./index";

export default {
  name: "SampleApp",
  data() {
    return {
      //sessionOptions: [
      //  { text: "Session 1", value: "1" },
      //  { text: "Session 2", value: "2" },
      //  { text: "Session 3", value: "3" },
      //  { text: "Session 4", value: "4" }
      //],
      sessionOptions: [],
      MapToOptions: [
        { text: "Event", value: "1" },
        { text: "Session", value: "2" },
      ],
      //VisibleTo: { text: "Attendee", value: "1" },
      //VisibleToOptions: [
      //  { text: "Attendee", value: "1" },
      //  { text: "Speaker", value: "2" },
      //  { text: "Sponsor", value: "3" },
      //  { text: "Exhibitor", value: "4" }
      //],
      VisibleTo: ["Attendee"],
      VisibleToOptions: ["Attendee", "Speaker", "Exhibitor", "Sponsor"],
      //
      fields: [],
      fieldData: [],
      //FormId: "SF_TEST",
      FormId: "ArrowGerman",
      FormType: "2",
      FormName: "",
      MapTo: "1",
      SubmitButtonText: "Submit",
      SubmitMessage: "Thank you. You have successfully submitted.",
      AllowMultipleSubmission: false,
      AllowEditAfterSubmission: false,
      SubmitRecipients: [],
      FormTypeOptions: [
        { value: 1, label: "Poll" },
        { value: 2, label: "Survey" },
        { value: 3, label: "Form" },
      ],
      mySourceFields: [
        { type: "text", icon: "text_format", label: "Text" },
        { type: "paragraph", icon: "text_fields", label: "Paragraph" },
        { type: "checkboxes", icon: "check_box", label: "Checkboxes" },
        { type: "radio", icon: "radio_button_checked", label: "Mult. Choice" },
        { type: "date", icon: "event", label: "Date" },
        { type: "time", icon: "access_time", label: "Time" },
        { type: "dropdown", icon: "arrow_drop_down", label: "Dropdown" },
        { type: "email", icon: "email", label: "Email" },
        //{ type: "name", icon: "person", label: "Name" },
        //{ type: "simple_name", icon: "person_outline", label: "Simple Name" },
        //{ type: "address", icon: "home", label: "Address" },
        { type: "phone", icon: "phone", label: "Phone" },
        { type: "file", icon: "cloud_upload", label: "File Upload" },
        //{ type: "payment", icon: "payment", label: "Payment" },
        //{ type: "terms", icon: "ballot", label: "Terms" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "" },
        //{ type: "section_break", icon: "view_agenda", label: "Section Break" },
        //{ type: "page_break", icon: "call_to_action", label: "Page Break" }
      ],
      popupActive: false,

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        /*{
          headerName: 'ID',
          field: 'FormId',
          width: 125,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },*/

        {
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          headerName: "Session #",
          field: "SessionId",
          filter: true,
          width: 150,
        },
        {
          headerName: "Session Name",
          field: "Name",
          filter: true,
          width: 300,
        },
        {
          headerName: "Start Time",
          field: "StartDate",
          filter: true,
          width: 300,
        },
        {
          headerName: "End Time",
          field: "EndDate",
          filter: true,
          width: 300,
        },
      ],
    };
  },
  watch: {
    FormType(val) {
      if (val == "1") {
        this.MapTo = "2";
      }
    },
    SubmitButtonText(val) {
      if (val.trim() == "") {
        this.SubmitButtonText = "Submit";
      }
    },
    SubmitMessage(val) {
      if (val.trim() == "") {
        this.SubmitMessage = "Thank you. You have successfully submitted.";
      }
    },
    fields: {
      handler(val) {
        // console.debug(val)
      },
      deep: true,
    },
  },
  methods: {
    /**
     * When a value is input into the rendered form, echo it to the debug line
     */
    onInput(val, id) {
      // console.debug(`${id}: ` + JSON.stringify(val))
    },
    /**
     * Determine the name of the Element object based on the 'field_type' of the field data object
     */
    getElement(field) {
      const nameParts = field.field_type.split("_");
      for (let i = 0; i < nameParts.length; i++) {
        nameParts[i] =
          nameParts[i].charAt(0).toUpperCase() + nameParts[i].slice(1);
      }
      return nameParts.join("") + "Element";
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then((result) => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then((result) => {
          if (result) {
            vm.saveForm();
            alert("Form submitted!");
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    dieplayForm: function () {
      var docRef = con.eventDB
        .collection(cn)
        .doc("FormList")
        .collection("Forms")
        .doc(vm.FormId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            vm.fields = doc.data().FormJson;
            console.log(vm.fields);
            vm.FormType =
              doc.data().FormType == undefined ? 0 : doc.data().FormType;
            vm.MapTo = doc.data().MapTo == undefined ? 0 : doc.data().MapTo;
            vm.FormName =
              doc.data().FormTitle == undefined ? "" : doc.data().FormTitle;
            vm.SubmitButtonText =
              doc.data().SubmitButtonText == undefined
                ? ""
                : doc.data().SubmitButtonText;
            vm.AllowMultipleSubmission =
              doc.data().AllowMultipleSubmission == undefined
                ? ""
                : doc.data().AllowMultipleSubmission;
            vm.AllowEditAfterSubmission =
              doc.data().AllowEditAfterSubmission == undefined
                ? ""
                : doc.data().AllowEditAfterSubmission;
            vm.SubmitMessage =
              doc.data().SubmitMessage == undefined
                ? ""
                : doc.data().SubmitMessage;
            vm.Recipients =
              doc.data().Recipients == undefined ? "" : doc.data().Recipients;
            vm.RedirectTo =
              doc.data().RedirectTo == undefined ? "" : doc.data().RedirectTo;
            debugger;
            con.eventDB
              .collection(cn)
              .doc("SessionList")
              .collection("Sessions")
              .get()
              .then((querySnapshot) => {
                vm.sessionOptions = [];
                querySnapshot.docs.forEach((doc) => {
                  var sData = doc.data();
                  var sObj = {};
                  sObj.Selected = false;
                  sObj.SessionId = sData.SessionId;
                  sObj.Name = sData.Name;
                  sObj.StartDate = new Date(
                    sData.StartDate.seconds * 1000
                  ).toUTCString();
                  sObj.EndDate = new Date(
                    sData.EndDate.seconds * 1000
                  ).toUTCString();
                  vm.sessionOptions.push(sObj);
                });
                debugger;
                vm.gridOptions.api.forEachNode((node) => {
                  if (node.data.SessionId === "433000") {
                    // Master open detail.  You could also call node.setSelected( true ); for alternate design.
                    //node.setExpanded(true);
                    vm.gridOptions.api.selectNode(node, true);
                  }
                });
                //$scope.gridOptions.api.forEachInMemory(function(node) {
                //  if (node.data.country === "United States") {
                //    $scope.gridOptions.api.selectNode(node, true);
                //  }
                //});
              });
          } else {
            con.eventDB
              .collection(cn)
              .doc("SessionList")
              .collection("Sessions")
              .get()
              .then((querySnapshot) => {
                vm.sessionOptions = [];
                querySnapshot.docs.forEach((doc) => {
                  var sData = doc.data();
                  var sObj = {};
                  sObj.Selected = false;
                  sObj.SessionId = sData.SessionId;
                  sObj.Name = sData.Name;
                  sObj.StartDate = new Date(
                    sData.StartDate.seconds * 1000
                  ).toUTCString();
                  sObj.EndDate = new Date(
                    sData.EndDate.seconds * 1000
                  ).toUTCString();
                  vm.sessionOptions.push(sObj);
                });
              });
          }
        })
        .catch(function (error) {
          console.log("Error fetching Form:", error);
        });
    },
    saveForm: function () {
      console.log(this.fields);
      console.log(this.fieldData);
      var docRef = con.eventDB
        .collection(cn)
        .doc("FormList")
        .collection("Forms")
        .doc(vm.FormId);
      docRef
        .get()
        .then(function (doc) {
          if (!doc.exists) {
            debugger;
            var docObj = new Object();
            docObj.FormId = vm.FormId;
            docObj.FormType = vm.FormType;
            docObj.MapTo = vm.MapTo;
            docObj.FormTitle = vm.FormName;
            docObj.FormJson = vm.fields;
            docObj.SubmitButtonText = vm.SubmitButtonText;
            docObj.AllowMultipleSubmission = vm.AllowMultipleSubmission;
            docObj.AllowEditAfterSubmission = vm.AllowEditAfterSubmission;
            docObj.CreatedDate = new Date();
            docObj.LastModifiedDate = new Date();
            if (
              docObj.FormType == 1 ||
              (docObj.FormType == 2 && docObj.MapTo == 2)
            ) {
              docObj.Mapping = vm.getSelectedSessions();
            } else if (docObj.FormType == 2 && docObj.MapTo == 1) {
              docObj.Mapping = [];
            } else if (docObj.FormType == 3) {
              docObj.Mapping = vm.VisibleTo;
            }
            var ref = con.eventDB
              .collection(cn)
              .doc("FormList")
              .collection("Forms")
              .doc(vm.FormId)
              .set(docObj)
              .then(function () {
                console.log("sucess");
              })
              .catch(function (error) {
                console.error("Error creating Form: ", error);
              });
          } else {
            debugger;
            var mapping = [];
            if (vm.FormType == 1 || (vm.FormType == 2 && vm.MapTo == 2)) {
              mapping = vm.getSelectedSessions();
            } else if (vm.FormType == 3) {
              mapping = vm.VisibleTo;
            }
            con.eventDB
              .collection(cn)
              .doc("FormList")
              .collection("Forms")
              .doc(vm.FormId)
              .update({
                FormType: vm.FormType,
                FormTitle: vm.FormName,
                MapTo: vm.MapTo,
                Mapping: mapping,
                FormJson: vm.fields,
                SubmitButtonText: vm.SubmitButtonText,
                AllowMultipleSubmission: vm.AllowMultipleSubmission,
                AllowEditAfterSubmission: vm.AllowEditAfterSubmission,
                LastModifiedDate: new Date().getTime(),
              })
              .then(function () {
                console.log("Form Updated : " + vm.FormId);
              })
              .catch(function (error) {
                console.error("Error updating Form: ", error);
              });
          }
        })
        .catch(function (error) {
          console.log("Error saving Form:", error);
        });
    },
    getSelectedSessions() {
      let selectedRows;
      debugger;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        return selectedRows;
      } else {
        return [];
        //this.$vs.dialog({
        //  type: 'alert',
        //  position:'top-center',
        //  color: 'warning',
        //  title: 'Status',
        //  text: 'Please Select a Row',
        //  //accept: this.deleteRecord,
        //  acceptText: 'OK'
        //})
      }
    },
  },
  mounted() {
    vm = this;
    this.gridApi = this.gridOptions.api;
    vm.dieplayForm();
  },
  components: {
    FormWizard,
    AgGridVue,
    TabContent,
    QFormBuilder,
    TextElement,
    ParagraphElement,
    CheckboxesElement,
    RadioElement,
    DateElement,
    TimeElement,
    DropdownElement,
    EmailElement,
    NameElement,
    SimpleNameElement,
    AddressElement,
    PhoneElement,
    FileElement,
    PaymentElement,
    TermsElement,
    PageBreakElement,
    SectionBreakElement,
    "v-select": vSelect,
  },
};
</script>


<style lang="scss">
.fullscreen.q-drawer__backdrop {
  display: none !important;
}
.editable-element-action-buttons {
  display: flex;
  z-index: 99;
}
.source-field {
  width: 120px;
}
.q-drawer {
  transform: translateX(0) !important;
}
body:not(.q-body--layout-animate) .q-layout--prevent-focus {
  visibility: visible !important;
}
/*.q-form-paragraph textarea {
  display: none;
}
.q-form-paragraph .q-textarea {
  display: none;
}*/
.button-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 25px;
}
.q-drawer {
  background: transparent;
}
.q-tab-panels {
  background: transparent;
}
.info-ico {
  width: 18px;
  height: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #333;
  color: #333;
  font-weight: 400;
  font-size: 12px;
  border-radius: 50%;
}
.source-field {
  width: 129px;
}
button.q-btn.q-btn-item.non-selectable.no-outline.btn-fixed-width.q-btn--standard.q-btn--rectangle.q-btn--actionable.q-focusable.q-hoverable.q-btn--wrap.q-btn--dense {
  padding: 6px 0;
}
.q-page {
  padding: 20px;
  border: 1px solid #dfdfdf;
  border-left: 0;
  border-bottom: 0;
}
.demo-alignment {
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.demo-alignment > * {
  //margin-top: 0rem;
}
.mapped-form-sessions .ag-grid-table {
  height: 300px;
}
.demo-bottom-alignment {
  display: flex;
  align-self: flex-end;
}
h2,
.h2 {
  font-size: 24.36px !important;
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit !important;
  font-family: "Poppins", Helvetica, Arial, sans-serif !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
  color: #2c2c2c !important;
}
.page-header {
  margin-bottom: 20px;
}
</style>